import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36b2aeb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex justify-center relative z-2 pt-x3 mx-24 xl:mx-64",
  role: "menubar"
}
const _hoisted_2 = { role: "none" }
const _hoisted_3 = ["aria-label", "aria-expanded"]
const _hoisted_4 = { role: "none" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = { role: "none" }
const _hoisted_8 = {
  class: "absolute right-0 -mt-8 flex items-center",
  role: "none"
}

import { computed, ref, watch } from 'vue';
import MainNavigationHandler from '@/shared/navigation/site-navigation/MainNavigationHandler.vue';
import siteContextStore from '@/shared/content/site-context.store';
import navigationStore from '@/shared/navigation/navigation.store';
import { useRoute } from 'vue-router';
import DrawerDialog from '@/shared/dialog/DrawerDialog.vue';
import BusinessComponent from '@/shared/layout/Business/BusinessComponent.vue';
import useNavigationRenderer from '@/shared/navigation/site-navigation/useNavigationRenderer';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import navigationTrackingService from '@/shared/tracking/navigation-tracking.service';
import MobilePageSeoHeader from '@/shared/layout/page-header/mobile/MobilePageSeoHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobilePageHeader',
  setup(__props) {

const { deselectSubItems, getSelectedItemByIndex } = useNavigationRenderer();

const route = useRoute();
const showMenu = ref(false);
const frontpageLink = computed(() => siteContextStore.settings.frontPageUrl);
const searchLink = siteContextStore.getSearchPageLink();

const onNavigationVisibilityChange = (visible: boolean): void => {
    trackCloseIfSelectedMenuItem();
    if (!visible) {
        navigationStore.clearActiveMainNavigation();
        deselectSubItems(-1);
    }
};

const trackCloseIfSelectedMenuItem = () => {
    const hasActiveMenu = !!getSelectedItemByIndex(0);
    if (hasActiveMenu) {
        navigationTrackingService.menuItem(null);
    }
};

const openMenu = (): void => {
    navigationStore.setActiveSearch(false);
    showMenu.value = !showMenu.value;
};

const onSearchClick = (): void => {
    showMenu.value = true;
    navigationTrackingService.searchLink();
    navigationStore.toggleActiveSearch();
};

watch(
    () => route.path,
    () => {
        showMenu.value = false;
    },
);

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("button", {
          class: "absolute left-0 p-12 -ml-12 mr-10 -mt-12",
          "aria-label": _ctx.$dictionary.get('global/a11y/openmenu'),
          role: "menuitem",
          "aria-expanded": showMenu.value,
          "aria-owns": "mobile-menu",
          "aria-haspopup": "true",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openMenu()), ["prevent"]))
        }, [
          _createVNode(_component_c_icon, {
            height: "20",
            width: "20",
            name: "icon-burger",
            "aria-hidden": "true"
          })
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          href: _unref(frontpageLink),
          role: "none"
        }, [
          _createVNode(_component_c_icon, {
            name: "icon-bolia-logo-simple",
            class: "w-70 h-18 mt-1 anim-nav-text-color"
          }),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$dictionary.get('global/a11y/gotofrontpage')), 1)
        ], 8, _hoisted_5)
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(RouterLinkConditional, {
            to: _unref(searchLink).url,
            role: "menuitem",
            title: _ctx.$dictionary.get('global/a11y/opensearch'),
            class: "p-10",
            "aria-owns": _unref(searchLink).url,
            "aria-haspopup": "menu",
            "aria-expanded": _unref(navigationStore).hasActiveSearch,
            tabindex: "0",
            onKeydown: _withKeys(_withModifiers(onSearchClick, ["prevent"]), ["enter"]),
            onClick: _withModifiers(onSearchClick, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_c_icon, {
                name: "icon-search",
                class: "h-18",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          }, 8, ["to", "title", "aria-owns", "aria-expanded", "onKeydown", "onClick"]),
          _createVNode(BusinessComponent, {
            name: "MiniBasket",
            class: "p-10 -mr-10"
          })
        ])
      ])
    ]),
    _createVNode(DrawerDialog, {
      "is-open": showMenu.value,
      "onUpdate:is-open": _cache[1] || (_cache[1] = ($event: any) => ((showMenu).value = $event)),
      "show-close-button": true,
      position: "left",
      onVisible: onNavigationVisibilityChange
    }, {
      default: _withCtx(() => [
        _createVNode(MainNavigationHandler)
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(MobilePageSeoHeader)
  ]))
}
}

})